<template>
  <button
    class="group flex flex-grow items-center justify-between rounded-full border py-3 pl-6 pr-3"
    :class="{
      'border-gray-600 bg-white text-gray-600 outline-[3px] focus:outline focus:outline-red-200': type === 'light',
      'border-white bg-transparent text-white outline-none': type === 'dark'
    }"
    @click="copyLink">
    <span class="my-1 mr-4">Copy link</span>
    <div
      class="relative flex-shrink-0 overflow-hidden rounded-full p-1.5 transition-colors duration-300 group-hover:bg-transparent"
      :class="{
        'bg-gray-600': type === 'light',
        'bg-white': type === 'dark'
      }">
      <div
        class="bg-pink-blue absolute inset-0 rounded-full opacity-0 transition-opacity duration-300 group-hover:opacity-100" />

      <div
        class="relative h-5 w-5"
        :class="{
          'text-white': type === 'light',
          'text-gray-600 duration-100 group-hover:text-white': type === 'dark'
        }">
        <Presence>
          <Motion
            :key="copied"
            :initial="{ opacity: 0, x: 50 }"
            exit-before-enter="true"
            :animate="{
              opacity: 1,
              x: 0,
              transition: { delay: 0.1 }
            }"
            :exit="{ opacity: 0, x: -50 }"
            class="absolute h-full w-full">
            <ButtonBaseIcon
              v-if="copied === false"
              href-type="copy"
              class="h-5 w-5" />

            <SvgAnimatedCheck
              v-if="copied === true"
              class="h-5 w-5" />
          </Motion>
        </Presence>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
  // @ts-nocheck
  import { ref } from 'vue'

  import { Motion, Presence } from '@motionone/vue/dist/motion-vue.ssr.js'

  type CopyIconProps = {
    url: string
    type: 'light' | 'dark'
  }

  const props = defineProps<CopyIconProps>()
  const copied = ref(false)
  function copyLink() {
    copied.value = true
    navigator.clipboard.writeText(props.url)

    setTimeout(() => {
      copied.value = false
    }, 2000)
  }
</script>
